import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, DIMENSION_META } from "@/lib/api";
import { Clock, ArrowRight } from "lucide-react";

export default function Scenarios() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/scenarios").then((r) => setItems(r.data)); }, []);

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-12 py-10 fade-up">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-slate-500 mb-1">Practice hard moments</div>
        <h1 className="font-serif text-4xl text-[#0B1E36]">Scenario simulations</h1>
        <p className="text-slate-600 mt-3 max-w-2xl">Branching moments from real school leadership. Choose, receive AI-coached feedback, capture what you'd do next time.</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((s) => {
          const meta = DIMENSION_META[s.dimension];
          return (
            <Link key={s.id} to={`/app/scenarios/${s.id}`} data-testid={`scenario-${s.id}`} className="bg-white rounded-2xl border border-slate-200 overflow-hidden card-lift group">
              <div className="h-40 overflow-hidden">
                <img src={s.cover} alt={s.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs mb-3">
                  <span className="uppercase tracking-widest font-semibold" style={{ color: meta.color }}>{meta.label}</span>
                  <span className="text-slate-300">•</span>
                  <span className="inline-flex items-center gap-1 text-slate-500"><Clock className="h-3 w-3" /> {s.duration_min} min</span>
                </div>
                <h3 className="font-serif text-xl text-[#0B1E36] mb-2 leading-snug">{s.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.context}</p>
                <div className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#EC4899]">
                  Enter scenario <ArrowRight className="h-4 w-4" />
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
